import { render, staticRenderFns } from "./uploadImgApply.vue?vue&type=template&id=5d5f12d2&"
import script from "./uploadImgApply.vue?vue&type=script&lang=js&"
export * from "./uploadImgApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports